"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMockProgress = void 0;
const react_1 = require("react");
const useInterval_1 = require("./useInterval");
const DEFAULT_TIME_INTERVAL = 500;
const DEFAULT_AUTO_COMPLETE = true;
const PROGRESS_LOWER_LIMIT = 0;
const PROGRESS_UPPER_LIMIT = 100;
const MANUAL_PROGRESS_UPPER_LIMIT = 98;
function useMockProgress(props) {
    var _a, _b;
    const timeInterval = (_a = props === null || props === void 0 ? void 0 : props.timeInterval) !== null && _a !== void 0 ? _a : DEFAULT_TIME_INTERVAL;
    const autoComplete = (_b = props === null || props === void 0 ? void 0 : props.autoComplete) !== null && _b !== void 0 ? _b : DEFAULT_AUTO_COMPLETE;
    const [progress, setProgress] = (0, react_1.useState)(PROGRESS_LOWER_LIMIT); // progress value
    const increment = (0, react_1.useRef)(1); // increment for progress value update
    const shouldProgress = (0, react_1.useRef)(false); // manage start, finish progress callbacks
    // max value progress will reach automatically
    // if auto complete off,
    const upperLimit = (0, react_1.useMemo)(() => {
        return autoComplete ? PROGRESS_UPPER_LIMIT : MANUAL_PROGRESS_UPPER_LIMIT;
    }, [autoComplete]);
    // randomly increment progress in increments between 1 and 10
    const changeIncrement = (0, react_1.useCallback)(() => {
        increment.current = Math.floor(Math.random() * 10) + 1;
    }, []);
    // create interval to update progress
    const intervalRef = (0, useInterval_1.default)(() => {
        if (shouldProgress.current) {
            if (progress + increment.current <= upperLimit) {
                setProgress(progress + increment.current);
                changeIncrement();
            }
            else {
                setProgress(upperLimit);
                clearInterval(intervalRef.current);
                intervalRef.current = undefined;
            }
        }
    }, timeInterval);
    // complete progress and clear interval
    const finish = (0, react_1.useCallback)(() => {
        setProgress(PROGRESS_UPPER_LIMIT);
        shouldProgress.current = false;
        clearInterval(intervalRef.current);
        intervalRef.current = undefined;
    }, [intervalRef]);
    // start progress
    const start = (0, react_1.useCallback)(() => {
        if (intervalRef.current) {
            shouldProgress.current = true;
            setProgress(PROGRESS_LOWER_LIMIT);
        }
    }, [intervalRef]);
    return { progress, start, finish };
}
exports.useMockProgress = useMockProgress;
